import { ChevronDownIcon } from '@sketchnote/icons';
import React from 'react';
import Select from 'react-select';
import { Styles } from 'react-select';

export const SelectStyleTwo: Styles<any, false> = {
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  control: (styles) => ({
    ...styles,
    backgroundColor: '#F6F7F9',
    paddingTop: '13px',
    paddingBottom: '13px',
    paddingLeft: '12px',
    paddingRight: '12px',
    borderRadius: '6px',
    borderColor: '#E2E4E9',
    fontWeight: 400,
    fontSize: '1.6rem',
    color: '#131720',
  }),
  menu: (styles) => ({ ...styles, padding: '8px', borderRadius: '6px' }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#F6F7F9'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      paddingTop: '13px',
      paddingBottom: '13px',
      paddingLeft: '12px',
      //paddingRight: '17px',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '22px',
      color: isDisabled ? '#ccc' : isSelected || isFocused ? '#254DDA' : '#878A92',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
      },
    };
  },
};

export type Option = { label: string; value: string };

const DropdownIndicator = () => {
  return <ChevronDownIcon fill={'#878A92'} />;
};

export interface DropdownTwoProps {
  placeholder?: string;
  options: Option[];
  onChange?: (prop: Option) => void;
  disabled?: boolean;
  label?: string;
  className?: string;
  isMulti?: boolean;
  required?: boolean;
  value?: Option;
  id?: string;
  [key: string]: any;
}

export const DropdownTwo = ({
  placeholder,
  options,
  onChange,
  disabled,
  value,
  className,
  id,
  ...otherProps
}: DropdownTwoProps): JSX.Element => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      styles={SelectStyleTwo}
      className={className}
      isDisabled={disabled}
      isLoading={false}
      isClearable={false}
      isRtl={false}
      id={id}
      isSearchable={false}
      components={{
        DropdownIndicator: DropdownIndicator,
        IndicatorSeparator: () => null,
      }}
      {...otherProps}
    />
  );
};
